export default defineNuxtRouteMiddleware(async (to, from) => {
  const { user } = useUserSession();
  const accessToken = to.query.accessToken as string;

  const { $api } = useNuxtApp();

  // if user is admin don't do anything
  if (user.value?.isAdmin) {
    return;
  }

  // if user is agency-user, check if the user has permission to the current campaign
  try {
    await $api("/check-campaign-permission", {
      params: { slug: to.params.slug, accessToken },
    });
  } catch (error) {
    console.error(error);
    return navigateTo("/campaigns");
  }
});
